/**
 * Currently A/B testing this dropdown from the site header concept
 *
 * Should be moved into copycat with the main site-header styles if
 * we stick with this and roll it out elseware
 */
import '../polyfills/web_components'
import './expando.scss'
import './mobile_nav_overrides.scss'

const expandoClass = 'pe-site-header__item-expando'
const openedExpandoClass = `${expandoClass}--opened`
const responsiveMediaQuery = 'screen and (max-width: 1240px)'

const mql = window.matchMedia(responsiveMediaQuery)
mql.addEventListener('change', e => {
  if (e.matches) {
    // When switching to smaller viewports, close all expanded dropdowns.
    closeOnContentClick()
  } else {
    // When window size goes beyond max width, make sure we close all responsive
    // menus that may have been opened.
    const button = document.querySelector('.pe-site-header__expand')
    if (button.ariaExpanded === 'true') {
      button.click()
    }
  }
})

function toggleMainPageScroll () {
  // Wait until animation is done before disabling main page scroll.
  setTimeout(function () {
    const expanded = $('.pe-site-header__expansion--open').length === 1
    $('html').toggleClass('noscroll', expanded)
    $('body').toggleClass('noscroll', expanded)
  }, 200)
}

function closeOnContentClick () {
  $(`.${openedExpandoClass}`).removeClass(openedExpandoClass)
  $('#main').off('click', closeOnContentClick)
}

$(() => {
  $('.pe-site-header__item-expando')
    .filter((_index, el) => !$(el).data('expando'))
    .data('expando', true)
    .click(function (e) {
      const $expando = $(this)
      const isOpen = $expando.hasClass(openedExpandoClass)

      // Close any others that are open
      $(`.${openedExpandoClass}`)
        .not($expando)
        .removeClass(openedExpandoClass)

      // Toggle this expando
      $expando.toggleClass(openedExpandoClass, !isOpen)

      $('#main').on('click', closeOnContentClick)
    })

  // This was only there while our CSS loaded
  $('.pe-site-header__expando-container').removeAttr('hidden')

  // remove scroll from main page when this is expanded
  $('.pe-site-header__expand, .pe-site-header__expansion__close')
    .on('click', toggleMainPageScroll)
})
